import { render } from "./IconComplete.vue?vue&type=template&id=dc390384"
import script from "./IconComplete.vue?vue&type=script&lang=js"
export * from "./IconComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__